import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cs_token";

export const api = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
};

const saved = localStorage.getItem(TOKEN_KEY);
if (saved) setAuthToken(saved);

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      setAuthToken(null);
      const path = window.location.pathname;
      if (!path.startsWith("/sign") && path !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const pageImageUrl = (docId, pageIndex) =>
  `${API}/documents/${docId}/pages/${pageIndex}.png`;

export const signedPdfUrl = (envId) => `${API}/envelopes/${envId}/signed.pdf`;
export const downloadOwnerPdf = async (envId, mode) => {
  const r = await api.get(`/envelopes/${envId}/download`, { params: { certificate_mode: mode }, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "document.pdf";
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
